"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
const react_1 = __importStar(require("react"));
const react_device_detect_1 = require("react-device-detect");
require("./select.css");
;
const Select = ({ error, label, labelMobile, value, onChange, disabled, name, id, options, errorMessage, }) => {
    // trigger onChange event if options length is 1
    id = id ? id : `select-${(new Date()).getTime().toString()}`;
    const [triggered, setTriggered] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!triggered && Array.isArray(options) && options.length == 1 && options[0].value !== '') {
            const input = document.getElementById(id);
            input.value = options[0].value;
            var event = new Event('change', {
                'bubbles': true,
                'cancelable': false
            });
            input.dispatchEvent(event);
            setTriggered(true);
        }
    }, [options]);
    return (react_1.default.createElement("div", { className: "select-wrapper" },
        react_1.default.createElement("div", { className: error ? "background-white select-error" : "background-white" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("span", { className: labelMobile ? "select-label label-desktop" : "select-label" }, label),
                labelMobile && react_1.default.createElement("span", { className: "select-label label-mobile" }, labelMobile)),
            react_1.default.createElement("select", { className: react_device_detect_1.isMobile ? "select select-mobile" : "select", name: name, id: id, onChange: onChange, value: value, disabled: disabled }, options.map((option, index) => {
                var _a;
                return (react_1.default.createElement("option", { key: index, value: option.value, disabled: option.disabled && option.disabled === true }, (_a = option.name) !== null && _a !== void 0 ? _a : ''));
            }))),
        error ? react_1.default.createElement("div", { className: "error" }, errorMessage) : null));
};
exports.Select = Select;
//# sourceMappingURL=select.js.map